export default "__VITE_ASSET__2247abaf__"